import React from 'react';
import { useAuthState } from '@trp-ta-nitro/auth-react';
import config from '../../config';
import styles from './styles.css';

const RetirementContactSection = () => {
  const authState = useAuthState();
  const isGuestTypeUser = !authState?.entitlements?.includes(
    'TRP_RET_EXTERNAL_USER_ACCESS'
  );

  return (
    <>
      <section className="next-instructions">
        <div className="step-contents">
          <h3 className="confirmation-section-headers">Add a beneficiary</h3>
          <p>
            If no beneficiary designation is in effect at your death, your
            surviving spouse will be considered your sole beneficiary. If you do
            not have a surviving spouse, your estate will be considered your
            sole beneficiary.*
          </p>
          <p>
            Visit the{' '}
            <a
              className="underlined-confirmation-links"
              href={
                isGuestTypeUser
                  ? `${config('clxUrl')}/usis/login/logout?sdurl=${config(
                      'clxUrl'
                    )}/usis/my-accounts/profile/beneficiaries`
                  : `${config('clxUrl')}/usis/my-accounts/profile/beneficiaries`
              }
              target="_blank"
              rel="noopener noreferrer">
              Beneficiaries page
            </a>{' '}
            to add or edit your beneficiary selections.
          </p>
        </div>
      </section>
      <section className="next-instructions">
        <div className="step-contents">
          <h3 className="confirmation-section-headers">
            Add a trusted contact
          </h3>
          <p>
            A trusted contact is a resource for T. Rowe Price to contact on your
            behalf, if necessary, to help protect your accounts from financial
            exploitation or to confirm your contact information if we are unable
            to reach you.
          </p>
          <p>
            Visit your{' '}
            <a
              className="underlined-confirmation-links"
              href={
                isGuestTypeUser
                  ? `${config('clxUrl')}/usis/login/logout?sdurl=${config(
                      'clxUrl'
                    )}/usis/my-accounts/profile/trusted-contacts`
                  : `${config(
                      'clxUrl'
                    )}/usis/my-accounts/profile/trusted-contacts`
              }
              target="_blank"
              rel="noopener noreferrer">
              Trusted Contacts page
            </a>{' '}
            to add or edit your trusted contact(s).
          </p>
        </div>
      </section>
      <style jsx>{styles}</style>
    </>
  );
};

export default RetirementContactSection;
